module.exports = __webpack_public_path__ + "media/images/flags/32/Saint-Helena-bb3103272c252b762c12ffd280488ff3.png";